import { useState, useEffect, useContext, useRef } from 'react';

import { requestApi } from '../../../../../../util/utility';
import { cmnContext } from '../../../../../common/CmnContext';
import { SaleListContext } from '../../../SaleListContext';


export function SaleListDetailPurchaseTicket(props: any) {

  const sale = props.sale;
  const isPlus = props.isPlus;

  const isPc = useContext(cmnContext).isPc;

  const {
    user,
  }= useContext(SaleListContext);

  const ticketFormRef = useRef<HTMLFormElement>(null);
  const creditFormRef = useRef<HTMLFormElement>(null);

  const [purchased, setPurchased] = useState<boolean>(false);
  const [dispErr, setDispErr] = useState<boolean>(false);


  const btnWrap = {
    flex: isPc? 1 : 'none',
    width: '100%',
    margin: isPc? '10px 20px' : 5,
  };


  // チケット購入
  const handleTicketSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    try {
    e.preventDefault();
    // 購入確認
    const purchaseCheck = await purchaseCheckApi();
    if(purchaseCheck.error) {
      // エラー
      throw 'purchase err';

    } else if(purchaseCheck.purchased) {
      // 所持中
      setPurchased(true);

    } else {
      // 購入アラート
      if (!window.confirm('この動画と交換します。よろしいですか？')) {
        return;
      }
      // 購入処理
      ticketFormRef?.current?.submit();
    }
    } catch(err) {
      setDispErr(true);
    }
  };


  // クレジットカード購入
  const handleCreditSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    try {
    e.preventDefault();
    // 購入確認
    const purchaseCheck = await purchaseCheckApi();
    if(purchaseCheck.error) {
      // エラー
      throw 'purchase err';

    } else if(purchaseCheck.purchased) {
      // 所持中
      setPurchased(true);

    } else {
      // 決済画面に移動
      creditFormRef?.current?.submit();
    }
    } catch(err) {
      setDispErr(true);
    }
  };


  // 購入前確認API(重複購入確認)
  async function purchaseCheckApi() {
    const resp = await requestApi({
      inc: '/backend/api/functions/user/sale/purchase_check',
      saleId: sale.id,
    });
    return resp;
  }


  return (
    <>
    {!purchased ?
      <>
        <div
          className="text-center"
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: isPc? 'row' : 'column',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
          }}
        >

          {/* チケット */}
          {sale.ticket > 0 &&
            <div style={btnWrap}>
              <form
                ref={ticketFormRef}
                action="/sale/sale_request"
                method="post"
                onSubmit={handleTicketSubmit}
              >
                <input className="sale_id" type="hidden" name="sale_id" value={sale.id} />
                <input type="hidden" name="mode" value="regist" />
                <button
                  type="submit"
                  id="ticket_submit"
                  value="交換"
                  className="btn btn-warning btn-block btn_customize"
                  style={{
                    padding: (!isPc && isPlus)? '5px 8px' : '10px 15px',
                  }}
                >
                  交換 ({sale.ticket}チケット) <span className="disp_ticket"></span><i className="fas fa-chevron-circle-right"></i>
                </button>
              </form>
            </div>
          }

          {/* クレカ */}
          {sale.price > 0 &&
            <div style={btnWrap}>
              <form
                ref={creditFormRef}
                method="post"
                action="/sale/sale_request"
                onSubmit={handleCreditSubmit}
              >
                <input type="hidden" name="sale_id" value={sale.id} />
                <input type="hidden" name="mode" value="regist" />
                <input type="hidden" name="pay_method" value="credit" />
                <input type="hidden" name="money" value={sale.price} />
                <button
                  type="submit"
                  value="購入"
                  className="btn btn-success btn-block btn_customize"
                  style={{
                    padding: (!isPc && isPlus)? '5px 8px' : '10px 15px',
                  }}
                >
                  購入 (¥{sale.price.toLocaleString()}) <span className="disp_price"></span><i className="fas fa-chevron-circle-right"></i>
                </button>
              </form>
            </div>
          }

        </div>
        
        {/* 銀行振込 */}
        {sale.price > 0 &&
          <p style={{
            textAlign: isPc? 'right' : 'center',
            fontSize: '90%',
            marginTop: 3,
          }}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                const w = window as any;
                if (w.openBankModal) {
                  w.openBankModal(
                    53,         // sell_type
                    sale.id,    // sell_type2
                    '動画レッスン：'+sale.name,  // sell_name
                    sale.price, // sell_price
                    1           // sell_amount
                  );
                }
              }}
            >
              ※ 銀行振込をご希望の方は<span style={{textDecoration: 'underline', color: 'blue'}}>こちら</span>
            </a>
          </p>
        }

        {dispErr &&
          <p style={{textAlign: 'center'}}>
            購入処理に失敗しました。<br />
            お手数をおかけしますがお問い合わせください。
          </p>
        }
      </>
    :
      <>
        <p style={{textAlign: 'center'}}>
          すでに購入いただいております。<br />
          ページを更新してご確認ください。<br />
          <button className='btn btn-primary' onClick={() => window.location.reload()}>
            ページを更新
          </button>
        </p>
      </>
    }
    </>
  );
}